import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router"
import { StopsService } from '../../services/stops.service';

@Component({
  selector: 'app-stop',
  templateUrl: './stop.component.html',
  styleUrls: ['./stop.component.css']
})
export class StopComponent implements OnInit {

  constructor(private route: ActivatedRoute, private stopsService: StopsService) { }
  mode: string = '';
  stop: string = '';
  id: string = '';
  data: any = [];
  arrivals: any;
  ngOnInit(): void {
    this.mode = this.route.snapshot.paramMap.get('mode');
    this.stop = this.route.snapshot.paramMap.get('stop');
    this.id = this.route.snapshot.paramMap.get('id');

    this.stopsService.searchStations(this.mode, this.stop)
    .subscribe(data => this.data = data);

    this.stopsService.getArrivals(this.mode, this.stop, this.id)
    .subscribe(data => this.data = data);
  }

}
